import React, { ReactNode, PropsWithChildren } from 'react';

import styled from 'styled-components';
import { theme } from '../../theme';
import { animated, useSpring } from 'react-spring';
import { useMeasure } from 'react-use';

export type BaseAccordionProps = {
  header: ReactNode;
  onToggleOpen: () => void;
  open: boolean;
};

const Header = styled.div`
  background-color: ${theme.colors.primary.white};
  cursor: pointer;

  &:hover {
    background-color: ${theme.colors.neutrals.transparentGrays[8]};
  }
`;

const Body = styled.div<{ open: boolean }>`
  height: 100%;
  overflow: hidden;
  background-color: ${theme.colors.primary.white};
`;

export const BaseAccordion: React.FC<PropsWithChildren<BaseAccordionProps>> = ({
  header,
  children,
  onToggleOpen,
  open,
  ...props
}) => {
  const [bodyRef, { height }] = useMeasure<HTMLDivElement>();

  const styleProps = useSpring({
    maxHeight: open ? height : 0,
    overflow: 'hidden',
    config: { duration: 200 },
  });

  return (
    <div {...props}>
      <Header onClick={onToggleOpen}>{header}</Header>
      <animated.div style={{ ...styleProps }}>
        <Body ref={bodyRef} open={open}>
          {children}
        </Body>
      </animated.div>
    </div>
  );
};
